import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userStatuses } from "../../../app/config/userStatuses";
import { fetchConsumers, setFilter } from "../../../app/slices/consumersSlice";
import { ListAdd } from "../../../assets/icons";
import { FilterMenu } from "../../filterMenu";
import { ScreenHeader } from "../../screenHeader";
import {useAuth} from "../../../hooks";
import {format} from "../../../utils/timeZoneUtils";
import CompanyService from "../../services/CompanyService";
import ConsumerService from "../../services/ConsumerService";

function UsersTableFilter({ filter, isCurrentUserAdmin, setFilter }) {
  const navigate = useNavigate();
  const { t } = useTranslation('UsersScreen', { keyPrefix: 'TableFilter' });
  const { t: t_button } = useTranslation('Buttons');
  const { t: t_pages } = useTranslation('Pages');
  const { t: t_common } = useTranslation('Common');
  
  let handleFilterChange = (field, value) => {
    setFilter(field, value?.value ?? value);
  };
  
  const handleCreateClick = () => {
    navigate(t_pages('userCreateLink'));
  }

  const onExportCsvPress = async () => {
    await ConsumerService.downloadCsvReport({isConsumer: false});
  }

  return (
    <>
      <ScreenHeader withSearch search={filter.search} onChange={(event) => handleFilterChange('search', event.target.value)} />
      <div className="fk-filter-container">

        {isCurrentUserAdmin &&
          <IconButton color="primary" aria-label="upload picture" component="button" onClick={handleCreateClick}>
          <img src={ListAdd} alt="button"/> {t_button('add')}
        </IconButton>}
        
        <div className="fk-filter">
          <FilterMenu
            datepicker
            label={t('joinDate.text')}
            options={[]}
            selected={filter.dateFrom}
            buttonText={`${t('joinDate.from')} ${filter.dateFrom ? format(filter.dateFrom, "YYYY-MM-DD") : ''}`}
            onChange={(option) => handleFilterChange('dateFrom', option)}
          />
          <FilterMenu
            datepicker
            options={[]}
            selected={filter.dateTo}
            buttonText={`${t('joinDate.to')} ${filter.dateTo ? format(filter.dateTo, "YYYY-MM-DD") : ''}`}
            onChange={(option) => handleFilterChange('dateTo', option)}
          />
          <FilterMenu
            label={t('status.text')}
            options={userStatuses}
            selected={userStatuses.find(s => s.value === filter.isBlocked)}
            onChange={(option) => handleFilterChange('isBlocked', option?.value)}
            tFunc={t}
            tPrefix="status."
          />
          <FilterMenu
              actionButton
              onClick={onExportCsvPress}
              buttonText={t_common('downloadCsv')}
          />
        </div>
      </div>
    </>
  );
}

export default UsersTableFilter;